import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MaterialModule } from '../../../assets/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// components
import { IgnoreWhitespaceDirective } from './directives/ignore-whitespace.directive';
import { EEVTrackClickDirective } from './directives/eev-track-click.directive';
import { EEVTrackFormStartDirective } from './directives/eev-track-formStart.directive';
import { RouterModule } from '@angular/router';
import { EEVTrackFieldErrorDirective } from './directives/eev-track-fieldError.directive';
import { EEVTrackFieldInteractionDirective } from './directives/eev-track-fieldInteraction.directive';
import { IconInfoComponent } from './components/icon-info/icon-info.component';
import { BeLogoV2Component } from './components/be-logo-v2/be-logo-v2.component';
import { ButtonComponent } from './components/be-button/be-button.component';
import { HelperTextComponent } from './components/be-helper-text/be-helper-text.component';
import { BeInputGroupReactiveComponent } from './components/be-input-group-reactive/be-input-group-reactive.component';
import { BeSelectReactiveComponent } from './components/be-select-reactive/be-select-reactive.component';
import { BeTooltipComponent } from './components/be-tooltip/be-tooltip.component';
import { CreatePasswordInputFieldComponent } from './components/create-password-input-field/create-password-input-field.component';
import { DescriptionListV2Component } from './components/description-list-v2/description-list-v2.component';
import { DescriptionListComponent } from './components/description-list/description-list.component';
import { EditableDlCardComponent } from './components/editable-dl-card/editable-dl-card.component';
import { IconArrowComponent } from './components/icon-arrow/icon-arrow.component';
import { IconBellComponent } from './components/icon-bell/icon-bell.component';
import { IconCaretV2Component } from './components/icon-caret-v2/icon-caret-v2.component';
import { IconCheckBadgeComponent } from './components/icon-check-badge/icon-check-badge.component';
import { IconInfoSmComponent } from './components/icon-info-sm/icon-info-sm.component';
import { IconInfoOutlineComponent } from './components/icon-info-outline/icon-info-outline.component';
import { IconApprovalThumbComponent } from './components/icon-approval-thumb/icon-approval-thumb.component';
import { IconLogoOldComponent } from './components/icon-logo-old/icon-logo-old.component';
import { IconLogoComponent } from './components/icon-logo/icon-logo.component';
import { IconSunComponent } from './components/icon-sun/icon-sun.component';
import { LoadingIconComponent } from './components/loading-icon/loading-icon.component';
import { RadioGroupContactMethodComponent } from './components/radio-group-contact-method/radio-group-contact-method.component';
import { TermsOfUseCheckboxComponent } from './components/terms-of-use-checkbox/terms-of-use-checkbox.component';
import { VerificationTipsPanelComponent } from './components/verification-tips-panel/verification-tips-panel.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ApprovalChanceComponent } from '../offers/components/approval-chance/approval-chance.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { LoanCardImageComponent } from '../offers/components/loan-card-image/loan-card-image.component';
import { LoanOfferComponent } from '../offers/components/loan-offer/loan-offer.component';
import { OffersCardComponent } from '../offers/components/offers-card/offers-card.component';
import { CreditOfferComponent } from '../offers/components/credit-offer/credit-offer.component';
import { IconCircleCheckComponent } from './components/icon-circle-check/icon-circle-check.component';
import { ElementScreenSizeDirective } from './directives/element-screen-size.directive';

@NgModule({
  declarations: [
    LoanOfferComponent,
    OffersCardComponent,
    CreatePasswordInputFieldComponent,
    TermsOfUseCheckboxComponent,
    VerificationTipsPanelComponent,
    IconLogoComponent,
    IconLogoOldComponent,
    IconCaretV2Component,
    IconSunComponent,
    IconArrowComponent,
    IconBellComponent,
    IconInfoComponent,
    DescriptionListComponent,
    DescriptionListV2Component,
    RadioGroupContactMethodComponent,
    HelperTextComponent,
    BeInputGroupReactiveComponent,
    EditableDlCardComponent,
    BeSelectReactiveComponent,
    ButtonComponent,
    LoadingIconComponent,
    IconInfoComponent,
    IconInfoSmComponent,
    IconCheckBadgeComponent,
    IgnoreWhitespaceDirective,
    EEVTrackClickDirective,
    EEVTrackFormStartDirective,
    EEVTrackFieldErrorDirective,
    EEVTrackFieldInteractionDirective,
    IconInfoComponent,
    CreditOfferComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    IconCircleCheckComponent,
    LoanCardImageComponent,
    FormsModule,
    ReactiveFormsModule,
    BeLogoV2Component,
    NgxMaskPipe,
    NgxMaskDirective,
    OverlayModule,
    ElementScreenSizeDirective,
    BeTooltipComponent,
    IconInfoOutlineComponent,
    IconApprovalThumbComponent,
    ApprovalChanceComponent,
  ],
  providers: [DatePipe, provideNgxMask()],
  exports: [
    IconCircleCheckComponent,
    LoanCardImageComponent,
    CreatePasswordInputFieldComponent,
    TermsOfUseCheckboxComponent,
    VerificationTipsPanelComponent,
    IconLogoComponent,
    IconLogoOldComponent,
    IconCaretV2Component,
    IconSunComponent,
    IconArrowComponent,
    IconBellComponent,
    IconInfoComponent,
    DescriptionListComponent,
    DescriptionListV2Component,
    RadioGroupContactMethodComponent,
    HelperTextComponent,
    BeInputGroupReactiveComponent,
    EditableDlCardComponent,
    BeSelectReactiveComponent,
    ButtonComponent,
    LoadingIconComponent,
    BeTooltipComponent,
    IconInfoComponent,
    IconInfoSmComponent,
    IconInfoOutlineComponent,
    IconApprovalThumbComponent,
    IconCheckBadgeComponent,
    IgnoreWhitespaceDirective,
    EEVTrackClickDirective,
    EEVTrackFormStartDirective,
    EEVTrackFieldErrorDirective,
    EEVTrackFieldInteractionDirective,
    ApprovalChanceComponent,
    LoanOfferComponent,
    OffersCardComponent,
    CreditOfferComponent,
    ElementScreenSizeDirective
  ],
})
export class SharedModule {}
